import { Injectable, inject } from '@angular/core';
import { UserContextService } from '../services/user-context.service';
import { MYABVV_NAV, BOTTOM_BAR_ITEM_IDS, NavGroup, NavItem } from './nav-model';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private userContext = inject(UserContextService);


  /**
   * Groups visible to the current user, empty groups removed.
   *
   * @param hasMember whether a member is currently selected. Internal staff with no
   *   member selected get an empty list (no navigation shown) until they pick a member.
   *   External users always have their own member, so this has no effect for them.
   */
  getGroups(hasMember: boolean = true): NavGroup[] {
    const internal = this.userContext.isInternalUser();
    // Internal staff with no member selected get NO navigation at all — they use the
    // member-search content page until they pick a member.
    if (internal && !hasMember) {
      return [];
    }
    return MYABVV_NAV
      .map(group => ({
        ...group,
        items: group.items.filter(item => (item.scope ?? 'all') === 'all' || internal),
      }))
      .filter(group => group.items.length > 0);
  }

  /** Flat list of all items visible to the current user. */
  getItems(): NavItem[] {
    return this.getGroups().flatMap(group => group.items);
  }

  /** The fixed mobile bottom-bar items, resolved from ids, in order. */
  getBottomBarItems(): NavItem[] {
    const all = this.getItems();
    return BOTTOM_BAR_ITEM_IDS
      .map(id => all.find(item => item.id === id))
      .filter((item): item is NavItem => !!item);
  }
}
